// src/hooks/useAmenities.js
import { useAppContext } from '../components/context/AppContext';

// Direct connection to global state - no more redundant layer
export const useAmenities = () => {
  const { state, actions } = useAppContext();

  // Map reservedAmenities to reservations for backward compatibility
  const reservations = state.reservedAmenities || [];

  return {
    // Amenities data and state
    amenities: state.amenities || [],
    amenitiesByHome: state.amenitiesByHome,
    loading: state.loading,
    error: state.error,
    reservedAmenities: state.reservedAmenities,
    amenitySubmited: state.amenitySubmited,
    
    // Reservations data (mapped for compatibility)
    reservations,
    
    // Fetch operations
    fetchAmenitiesByHome: actions.fetchAmenitiesByHome,
    fetchAmenities: actions.fetchAmenities,
    
    // Amenities CRUD operations
    addAmenity: actions.addAmenity,
    updateAmenity: actions.updateAmenity,
    deleteAmenity: actions.deleteAmenity,
    
    // Reservations
    reserveAmenity: actions.reserveAmenity,
    getReservedAmenitiesByType: actions.getReservedAmenitiesByType,
    getAllReservations: actions.getAllReservations,
    
    // Reservations CRUD operations
    addReservation: actions.addReservation,
    updateReservation: actions.updateReservation,
    deleteReservation: actions.deleteReservation,
    
    // Reservation approval/rejection
    approveReservation: actions.approveReservation,
    rejectReservation: actions.rejectReservation
  };
};
